module.exports = __webpack_public_path__ + "static/media/generic_vendor.ffe7e815.png";